const Chip = theme => {
  return {
    MuiChip: {
      variants: [{
        props: {
          color: 'primary'
        },
        style: {
          background: theme.palette.primary.light,
          color: theme.palette.text.primary
        }
      }, {
        props: {
          color: 'secondary'
        },
        style: {
          background: '#1A1C18',
          color: theme.palette.text.contrast
        }
      }, {
        props: {
          color: 'default'
        },
        style: {
          backgroundColor: theme.palette.grey[400],
          color: theme.palette.text.contrast
        }
      }]
    }
  };
};

export { Chip };
